import { render, staticRenderFns } from "./TemperatureMiniChip.vue?vue&type=template&id=1d915bc3&scoped=true"
import script from "./TemperatureMiniChip.vue?vue&type=script&lang=js"
export * from "./TemperatureMiniChip.vue?vue&type=script&lang=js"
import style0 from "./TemperatureMiniChip.vue?vue&type=style&index=0&id=1d915bc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d915bc3",
  null
  
)

export default component.exports